import { useTranslation } from 'react-i18next';
import { useGetFundraisingStatus } from '@/query/queries/fundraising/useGetFundraisingStatus';
import { FPG_ASSETS_STATUS } from '@/helpers/constants';
import { APP_LINKS } from '@/helpers/links';
import { InfoMessage } from '@/components/InfoMessage';
import s from './index.module.scss';

export const FundraisingMessages = () => {
  const { t } = useTranslation('dashboard');
  const { data: status } = useGetFundraisingStatus();

  if (!status) return null;

  let message = null;

  if (status.fpg_assets_status === FPG_ASSETS_STATUS.rejected && status.is_participating) {
    message = (
      <InfoMessage
        type="action"
        title={t('dashboard_messages.update_option_choice')}
        description={t('dashboard_messages.unable_to_approve_free_option')}
        linkUrl={APP_LINKS.fundraising}
        linkLabel={t('dashboard_messages.select_option')}
        linkState={{ step: 'fpg_select' }}
      />
    );
  }

  if (status?.fpg_assets_status === FPG_ASSETS_STATUS.review && status.is_participating) {
    message = (
      <InfoMessage
        type="info"
        title={t('dashboard_messages.application_pending_review')}
        description={t('dashboard_messages.documents_under_review')}
      />
    );
  }

  if (!message) return null;

  return <div className={s.wrapper}>{message}</div>;
};
